import { SearchModel } from './common';

export enum OriginType {
  PedidoCompra = 0,
  PedidoVenda = 1,
  AcertoManual = 2,
  Balanco = 3,
  RecebimentoMaterial = 4,
  EntradaProducao = 6,
  ConsumoProducao = 7,
  PerdaProducao = 8,
}

export enum MovementType {
  Entrada = 0,
  Saida = 1,
  Saldo = 2,
}

export enum StockItemType {
  Produto = 0,
  MateriaPrima = 1,
}

export const ORIGIN_TYPE_OPTIONS = [
  { value: OriginType.PedidoCompra, label: 'Pedido de Compra' },
  { value: OriginType.PedidoVenda, label: 'Pedido de Venda' },
  { value: OriginType.AcertoManual, label: 'Acerto Manual' },
  { value: OriginType.Balanco, label: 'Balanço / Inventário' },
  { value: OriginType.RecebimentoMaterial, label: 'Recebimento de Material' },
  { value: OriginType.EntradaProducao, label: 'Entrada de Produção' },
  { value: OriginType.ConsumoProducao, label: 'Consumo de Produção' },
  { value: OriginType.PerdaProducao, label: 'Perda de Produção' },
] as const;

export const MANUAL_ORIGIN_TYPE_OPTIONS = [
  { value: OriginType.AcertoManual, label: 'Acerto Manual' },
  { value: OriginType.Balanco, label: 'Balanço / Inventário' },
] as const;

export const MOVEMENT_TYPE_OPTIONS = [
  { value: MovementType.Entrada, label: 'Entrada' },
  { value: MovementType.Saida, label: 'Saída' },
  { value: MovementType.Saldo, label: 'Saldo' },
] as const;

export const MOVEMENT_TYPE_BY_ORIGIN: Record<number, { value: MovementType; label: string }[]> = {
  [OriginType.AcertoManual]: [
    { value: MovementType.Entrada, label: 'Entrada' },
    { value: MovementType.Saida, label: 'Saída' },
  ],
  [OriginType.Balanco]: [
    { value: MovementType.Saldo, label: 'Saldo' },
  ],
};

export const STOCK_ITEM_TYPE_OPTIONS = [
  { value: StockItemType.Produto, label: 'Produtos' },
  { value: StockItemType.MateriaPrima, label: 'Matérias-Primas' },
] as const;

export interface StockMovement {
  id: number;
  movement_date: string;
  origin_type: number;
  origin_reference?: string;
  purchase_order_id?: number;
  purchase_order_number?: number;
  order_id?: number;
  order_number?: string;
  material_receipt_item_id?: number;
  material_receipt_id?: number;
  production_order_id?: number;
  product_id?: number;
  raw_material_id?: number;
  movement_type: number;
  quantity: number;
  previous_balance?: number;
  new_balance?: number;
  purchase_price?: number;
  cost_price?: number;
  notes?: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  last_updated_by: string;
  // Campos auxiliares para exibição
  product_description?: string;
  product_sku?: string;
  raw_material_description?: string;
  raw_material_code?: string;
}

export interface StockMovementFormData {
  origin_type: number;
  movement_type: number;
  quantity: number;
  notes?: string;
  product_id?: number;
  raw_material_id?: number;
  purchase_price?: number;
  cost_price?: number;
}

export interface StockMovementSearchModel extends SearchModel {
  productId?: number;
  rawMaterialId?: number;
  originType?: number;
  movementType?: number;
  startDate?: string;
  endDate?: string;
}

export type StockMovementFilters = StockMovementSearchModel;

export const getOriginTypeLabel = (type: number): string => {
  return ORIGIN_TYPE_OPTIONS.find(o => o.value === type)?.label || 'Desconhecido';
};

export const getMovementTypeLabel = (type: number): string => {
  return MOVEMENT_TYPE_OPTIONS.find(o => o.value === type)?.label || 'Desconhecido';
};
